import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { COLORS, SPACING } from '../styles/constants';

const FooterWrapper = styled.footer`
  background-color: ${COLORS.dark};
  color: ${COLORS.white};
  padding: ${SPACING.lg} 0;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${SPACING.lg};
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  gap: ${SPACING.lg};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: ${SPACING.md};
  color: ${COLORS.primary};
`;

const FooterLink = styled(Link)`
  color: ${COLORS.white};
  text-decoration: none;
  display: block;
  margin-bottom: ${SPACING.xs};
  transition: color 0.3s ease;
  font-size: 0.8rem;

  &:hover {
    color: ${COLORS.primary};
  }
`;

const FooterText = styled.p`
  margin-bottom: ${SPACING.xs};
  line-height: 1.4;
  font-size: 0.8rem;
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: ${SPACING.lg};
  padding-top: ${SPACING.md};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.75rem;
`;

const LogoImage = styled.img`
  width: 300px;
`;

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (e, id) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const targetElement = document.getElementById(id);
        if (targetElement) {
          const offset = targetElement.offsetTop - 100;
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        const offset = element.offsetTop - 100;
        window.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterSection>
          <LogoImage src="/Cropped_Banner_transparent.png" alt="JNAR Logo" />
        </FooterSection>

        <FooterSection>
          <FooterTitle>JNAR</FooterTitle>
          <FooterText>Email: info@jnarconsulting.com</FooterText>
          <FooterText>Phone: 514-757-6845</FooterText>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/contact">Contact Us</FooterLink>
          <FooterLink to="/#services" onClick={(e) => handleScroll(e, 'services')}>Services</FooterLink>
          <FooterLink to="/#industries" onClick={(e) => handleScroll(e, 'industries')}>Industries</FooterLink>
          <FooterLink to="/#about" onClick={(e) => handleScroll(e, 'about')}>About Us</FooterLink>
        </FooterSection>
      </FooterContainer>

      <Copyright>
        © {new Date().getFullYear()} JNAR. All rights reserved.
      </Copyright>
    </FooterWrapper>
  );
};

export default Footer; 